import memoize from 'memoize-one';
import { orderBy, uniqBy, first } from 'lodash';
import moment from 'moment';
import messages from './classesStudentsMessages';

export const paginate = memoize((array, page, limit, offset) =>
  array.slice((page - 1) * limit - offset, page * limit - offset),
);

export const filterGroups = memoize((groups, params) =>
  groups.filter((group) => {
    const matchIdCSchool =
      [null, undefined, ''].includes(params.idCSchool) || group.idCSchool === params.idCSchool;
    const matchLevelName =
      [null, undefined, ''].includes(params.levelName) || group.levelName === params.levelName;
    const matchPeriod =
      [null, undefined, ''].includes(params.period) || group.period === params.period;
    const matchYear = params.year.toString() === group.year.toString();
    return matchIdCSchool && matchLevelName && matchPeriod && matchYear;
  }),
);

export const getYears = (groups = []) => {
  if (!groups.length) return [];
  let auxYear = [];
  const groupYears = uniqBy(groups.map((e) => e.year));
  groupYears.sort().reverse();
  if (!groupYears.includes(moment(new Date()).year().toString())) {
    auxYear.push(moment(new Date()).year().toString());
  }

  auxYear = auxYear.concat(groupYears);
  return auxYear;
};

export const getStatus = (evaluations = []) => uniqBy(evaluations.map((e) => e.status));

export const getStatusOptions = (status = [], intl) =>
  status.map((s) => ({
    label: messages[`status_${s}`] ? intl.formatMessage(messages[`status_${s}`]) : s,
    value: s,
  }));

export const getApplicationOptions = (applications = [], intl) =>
  applications.map((a) => ({
    label: messages[`application_${a}`] ? intl.formatMessage(messages[`application_${a}`]) : a,
    value: a,
  }));

export const getApplications = (evaluations = []) => uniqBy(evaluations.map((e) => e.application));

export const getSchoolOptions = (groups) => {
  if (!groups) return [];
  const schools = uniqBy(
    groups.map((g) => ({
      value: g.idCSchool,
      label: `${g.schoolName}${g.schoolCity ? ` - ${g.schoolCity.toUpperCase()}` : ''}`,
    })),
    (d) => d.value,
  );

  console.log('schools', schools);
  return schools;
};

export const getLevelOptions = (groups, params) => {
  if (!groups) return [];
  const tmp = uniqBy(
    groups
      .filter((g) => g.idCSchool === params.idCSchool)
      .map((g) => ({ value: g.levelName, label: g.levelName })),
    (d) => d.value,
  );
  return orderBy(tmp, (g) => g.label);
};

export const getPeriodOptions = (groups, params) => {
  if (!groups) return [];
  const tmp = uniqBy(
    groups
      .filter((g) => g.idCSchool === params.idCSchool)
      .map((g) => ({ value: g.period, label: g.period })),
    (d) => d.value,
  );
  return orderBy(tmp, (g) => g.label);
};

export const getEvaluationInformation = (data) => {
  const titles = data.evaluation.catalogings.map((el) => el.name);

  if (titles.length === 0) {
    return data;
  }
  if (titles.length === 1) {
    data.title = first(titles);
  } else {
    const lastCataloging = titles[titles.length - 1];
    titles.pop();
    const catalogingsArray = titles.join(', ');
    const catalogings = catalogingsArray.concat(` e ${lastCataloging}`);
    data.title = catalogings;
  }

  return data;
};
